<template>
  <div>
    <v-toolbar color="primary" dark>
      <v-toolbar-title
        >{{ $t('Archives') }} ({{ totalItemsInProgress.length }}). {{ $t('Errors') }}: {{ totalErrors }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <!-- <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="openUploadCsv">
            <v-list-item-title>{{ $t('Upload_CSV') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-toolbar>
    <v-list>
      <v-list-item v-for="archive in archives" :key="archive.mocId">


        <template v-slot:prepend>
          <v-progress-circular class="ms-2 me-6" :size="25" :width="3" indeterminate 
            v-if="processing.indexOf(archive.mocId) > -1 && errors.indexOf(archive.mocId) === -1">
          </v-progress-circular>
          <v-avatar color="white" v-if="errors.indexOf(archive.mocId) > -1">
            <v-icon color="red">mdi-alert-circle-outline</v-icon>
          </v-avatar>
          <v-avatar color="white" v-if="processing.indexOf(archive.mocId) === -1 && errors.indexOf(archive.mocId) === -1">
            <v-icon color="green">mdi-check-circle-outline</v-icon>
          </v-avatar>
        </template>
        <v-list-item-title>
          <router-link v-if="!isEmoc1Id(archive.mocId)" :to="getMocUrl(archive.mocId)">
            <strong>{{ archive.mocId }}</strong>
          </router-link>
          <strong v-else>{{ archive.mocId }}</strong>
        </v-list-item-title>
        <template v-slot:append>
          <v-avatar color="white">
            <v-icon color="red" @click="remove(archive.mocId)" v-if="processing.indexOf(archive.mocId) > -1">
              mdi-delete-outline
            </v-icon>
            <v-icon color="grey" @click="retry(archive.mocId)" v-if="errors.indexOf(archive.mocId) > -1 && processing.indexOf(archive.mocId) === -1">
              mdi-refresh
            </v-icon>
          </v-avatar>
        </template>
      </v-list-item>
    </v-list>

    <!-- <v-dialog max-width="400" v-model="showUploader">
      <div v-if="showUploader">
        <v-system-bar color="primary" height="40" window>
          <span></span>
          <v-spacer></v-spacer>
          <v-btn @click="showUploader = false" icon><v-icon color="orange">cancel</v-icon></v-btn>
        </v-system-bar>
        <v-card>
          <v-container>
            <v-form ref="form" v-model="uploaderValid">
              <v-file-input v-model="uploadedFile" :loading="loadingFile" autofocus show-size :rules="rules" accept=".csv">
              </v-file-input>
              <v-btn @click="loadFile">Load file</v-btn>
            </v-form>
          </v-container>
        </v-card>
      </div>
    </v-dialog> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ArchiveList',
  data() {
    return {
      uploadedFile: [],
      loadingFile: false,
      rules: [
        v => (v && v.size ? true : 'Required'),
        value => (value && value.size < 1000000) || 'Size should be less than 1 MB'
      ],
      showUploader: false,
      uploaderValid: false
    }
  },
  computed: {
    ...mapState('archivingMocs', ['processing', 'errors', 'archives']),
    totalItemsInProgress() {
      return this.processing
    },
    totalErrors() {
      return this.errors.length
    }
  },
  methods: {
    remove(mocId) {
      this.$store.dispatch('archivingMocs/remove', mocId)
    },
    retry(mocId) {
      this.$store.dispatch('archivingMocs/retry', mocId)
    },
    openUploadCsv() {
      this.showUploader = true
      this.uploadedFile = []
    },
    getMocUrl(id) {
      return `${id.substring(0, id.indexOf('-'))}/moc/${id}`
    },
    isEmoc1Id(mocId) {
      return mocId.toLowerCase().startsWith('emoc-')
    },
  }
}
</script>

<style></style>
